// src/components/School/NoticeBoard.jsx

import React from "react";
import { MegaphoneIcon, PencilSquareIcon, SparklesIcon } from "@heroicons/react/24/solid";

const notices = [
  {
    title: "Admissions open for 2025-26",
    icon: <MegaphoneIcon className="h-6 w-6 text-indigo-600" />,
  },
  {
    title: "Mid-term exams begin from Nov 10",
    icon: <PencilSquareIcon className="h-6 w-6 text-yellow-600" />,
  },
  {
    title: "Annual Day on Dec 15",
    icon: <SparklesIcon className="h-6 w-6 text-pink-600" />,
  },
];

const NoticeBoard = () => (
  <section className="py-10 bg-gray-50">
    <div className="max-w-6xl mx-auto px-4">
      <h2 className="text-3xl font-bold text-indigo-700 mb-6">📢 Latest Notices</h2>

      <div className="space-y-4">
        {notices.map((notice, index) => (
          <div
            key={index}
            className="flex items-start gap-4 bg-white p-5 rounded-lg shadow hover:shadow-md border transition duration-300"
          >
            <div className="flex-shrink-0">{notice.icon}</div>
            <p className="text-gray-800 text-lg font-medium">{notice.title}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default NoticeBoard;
